import React from "react"

import PackageSections from "~components/pages/listing/pricing/package-sections"
import { useCurrentListing } from "~components/providers/current-listing-provider"
import BottomDrawer from "~components/shared/drawers/bottom-drawer"
import ListingContactBanner from "~components/pages/listing/listing-contact-banner"

interface Props {
    readonly isOpen?: boolean
    readonly onClose: () => void
}

export default function ListingPricingDrawer({ isOpen, onClose }: Props) {
    const { currentListing } = useCurrentListing()

    if (!isOpen) {
        return null
    }

    return (
        <BottomDrawer
            isOpen={isOpen}
            onClose={onClose}
            shouldHaveHorizontalPadding
        >
            <PackageSections
                hasNextAvailableDate={!!currentListing.next_availability}
                listingId={currentListing.id}
                published={currentListing.published || false}
                outfitterName={currentListing.outfitter.name}
                hideContinueButton={!currentListing.next_availability}
                renderBottomContent={() => (
                    <ListingContactBanner listing={currentListing} />
                )}
            />
        </BottomDrawer>
    )
}
